__turbopack_context__.v({
  "placeholder": "_1FQzJa_placeholder",
  "step": "_1FQzJa_step",
  "step-content": "_1FQzJa_step-content",
  "steps": "_1FQzJa_steps",
});
